import React, { useContext, useState } from 'react';
import store from '../../store';
import { createNewStory, newStoryObj } from '../../constants/stories'
// Material components
import {
    Button,
    TextField,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle
} from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles({
    btn: {
        border: '1px solid white',
        color: 'white',
        marginBottom: 40
    }
})
export default function NewStory() {
    const classes = useStyles();
    const { state } = useContext(store);
    const { user } = state;
    const [open, setOpen] = useState(false);
    const [title, setTitle] = useState('');

    const handleOpen = () => {
        if (user.isAnonymous) {
            window.alert('Sorry. Anonymous users cannot create new stories. Please create an account with a valid email.')
            return;
        }
        if (!user.emailVerified) {
            window.alert('Your email has not been verified. Please check you email and activate your account.')
            return
        }
        setOpen(open ? false : true)
    };

    const handleformData = (value) => {
        setTitle(value)
    }

    const handleSubmit = () => {
        if (title !== '') {
            createNewStory(newStoryObj(title, user), handleOpen);
        } else {
            window.alert('Please give a title')
        }
    }

    return (
        <div>
            <Button onClick={handleOpen}
                className={classes.btn} variant="outlined">
                Create a new story
            </Button>
            <Dialog open={open} onClose={handleOpen} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">New Story Title</DialogTitle>
                <DialogContent>

                    <TextField
                        autoFocus
                        margin="dense"
                        id="name"
                        label="New Story Title"
                        type="text"
                        fullWidth
                        value={title}
                        onChange={(e) => handleformData(e.target.value)}
                    />

                </DialogContent>
                <DialogActions>
                    <Button onClick={handleSubmit} color="primary">
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}